import React, { useState, useEffect } from 'react';
import { useIntl } from 'umi';
import classnames from 'classnames';
import { SearchBox, AutoComplete, SelectOptionWithGroup } from 'tea-component';
import { useThrottleFn } from 'ahooks';
import { getTextWithHighlight } from '@/pages/intelligence/utils/commonUtils';

import type { IKeywordsSelectProps } from '../../types';

import './index.scss';

export default function KeywordsSelect(props: IKeywordsSelectProps) {
  const { formatMessage } = useIntl();

  const { searchPlaceholder = formatMessage({ id: 'dbg_search_any_game' }), keywordsFetcher, value, onChange, entityType } = props;

  const [isOpen, setIsOpen] = useState(false);
  const [keyword, setKeyword] = useState(value || '');
  const [keywords, setKeywords] = useState<SelectOptionWithGroup[]>([]);

  const handleOpenChange = (payload: boolean) => {
    setIsOpen(payload);
  };

  const updateKeywords = async (payload: string) => {
    try {
      const data = await keywordsFetcher?.({
          entity_type: entityType,
          keyword: payload,
          system_type: "pc",
          complement: "1"
      });
      const list = Array.isArray( data?.result) ? data?.result : [];
      const keywordsTemp = list?.map((item) => ({
        value: item,
        text: getTextWithHighlight(item, payload),
      }));
      setKeywords(keywordsTemp);
    } catch (exception) {
      // 这里出现异常，不重置Keywords为空，因为保留上一次搜索到的关键字数据，用户还可以继续选择，清空了后，就直接不能选择了
    }
  };

  const { run: updateKeywordsRun } = useThrottleFn(updateKeywords, {
    wait: 600,
    leading: true,
    trailing: true,
  });

  const handleKeywordChange = (payload: string) => {
    if (!payload) {
      setKeyword('');
      setKeywords([]);
      setIsOpen(false);
      onChange?.('');
      return;
    }
    setKeyword(payload);
    updateKeywordsRun?.(payload);
  };

  const handleKeywordSelect = (payload?: string) => {
    const keywordTemp = payload || '';
    setKeyword(keywordTemp);
    setIsOpen(false);
    onChange?.(keywordTemp);
  };

  useEffect(() => {
    if (value !== keyword) {
      const valueTemp = value || '';
      setKeyword(valueTemp);
      handleKeywordChange(valueTemp);
    }
  }, [value]);

  return (
    <div className="dbi-mobile-compare-keyword-select">
      <AutoComplete
        open={!!keyword && isOpen}
        // open={true}
        placementOffset={0}
        overlayClassName={classnames('dbg-mobile-compare-keyword-select-overlay', {
          empty: !keywords?.length,
        })}
        options={keywords}
        onOpenChange={handleOpenChange}
        onChange={handleKeywordSelect}
      >
        {(ref) => (
          <SearchBox
            ref={ref}
            placeholder={searchPlaceholder}
            value={keyword}
            onSearch={handleKeywordSelect}
            onChange={handleKeywordChange}
          />
        )}
      </AutoComplete>
    </div>
  );
}
